export default __webpack_public_path__ + "static/media/turbo_motor.a819b3dd.png";